import { domain } from "../../Links/Links";

export function ConvertDollarToToman(
  setTomanValue,
  prevTomanValueRef,
  setTomanValueColor,
  setUpdatingTomanValueStatus,
) {
  setUpdatingTomanValueStatus(true);
  fetch(domain + "/convert_dollar_to_toman/", {
    method: "GET",
    credentials: "include",
  })
    .then((res) => res.json())
    .then((data) => {

      setUpdatingTomanValueStatus(false);
      const toman_value = data.toman_value;

      const ref = prevTomanValueRef.current;

      if (ref !== 0) {
        if (toman_value > ref) {
          setTomanValueColor("increase");
        } else if (toman_value < ref) {
          setTomanValueColor("shortage");
        } else {
          setTomanValueColor(null);
        }

        setTimeout(() => {
          setTomanValueColor(null);
        }, 3000);
      }
      prevTomanValueRef.current = toman_value;
      setTomanValue(toman_value);
    })
}
